import { all, fork, takeEvery } from 'redux-saga/effects';
import {
  LOAD_ACTIVITY_LOG_PROJECT_LIST,
  LOAD_PROJECT_ACTIVITY_LOG,
  LOAD_TASK_ACTIVITY_LOG,
} from 'constants/ActionTypes';
import { loadEntities } from 'helpers/utilHelpers';

function* loadActivityLogProjectList() {
  yield takeEvery(LOAD_ACTIVITY_LOG_PROJECT_LIST, loadEntities);
}

function* loadTaskActivityLog() {
  yield takeEvery(LOAD_TASK_ACTIVITY_LOG, loadEntities);
}

function* loadProjectActivityLog() {
  yield takeEvery(LOAD_PROJECT_ACTIVITY_LOG, loadEntities);
}

export default function* rootSaga() {
  yield all([fork(loadActivityLogProjectList), fork(loadProjectActivityLog), fork(loadTaskActivityLog)]);
}
